module.exports = __webpack_public_path__ + "static/media/restar.3e381a64.svg";